import { BookingDto, StopOrderDto } from '@/types/webapi';
import { isSameDay } from 'date-fns';

/**
 * Check if the stop order is valid
 * @param stopOrder - The stop order to check
 * @param params - The params to check against
 * @returns True if the stop order is valid, false otherwise
 */
export function hasValidStopOrder(
    stopOrder: StopOrderDto,
    params?: { serviceJourneyRef?: string; activeDate?: string; stopSequence?: number }
) {
    if (!params?.serviceJourneyRef || !params.activeDate || !params.stopSequence) return false;

    return (
        stopOrder.serviceJourneyRef === params.serviceJourneyRef &&
        stopOrder.activeDate === params.activeDate &&
        stopOrder.stopSequence === params.stopSequence &&
        !stopOrder.isCancelled
    );
}

/**
 * Check if the booking is valid
 * @param booking - The booking to check
 * @param params - The params to check against
 * @returns True if the booking is valid, false otherwise
 */
export function hasValidBooking(booking: BookingDto, params?: { serviceJourneyRef?: string; activeDate?: string; stopSequence?: number }) {
    if (!params?.serviceJourneyRef || !params.activeDate || !params.stopSequence) return false;

    return (
        booking.serviceJourneyRef === params.serviceJourneyRef &&
        isSameDay(booking.activeDate, params.activeDate) &&
        booking.stopSequence === params.stopSequence
    );
}
